import { render, staticRenderFns } from "./ExaminationDetails.vue?vue&type=template&id=18217370&scoped=true"
import script from "./ExaminationDetails.vue?vue&type=script&lang=js"
export * from "./ExaminationDetails.vue?vue&type=script&lang=js"
import style0 from "./ExaminationDetails.vue?vue&type=style&index=0&id=18217370&prod&scoped=true&lang=css"
import style1 from "./ExaminationDetails.vue?vue&type=style&index=1&id=18217370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18217370",
  null
  
)

export default component.exports